// extracted by mini-css-extract-plugin
module.exports = {"menu":"DropdownMenu_menu__3o7F8","trigger":"DropdownMenu_trigger__2ite8","menu_wrapper":"DropdownMenu_menu_wrapper__36Izt","menuItem":"DropdownMenu_menuItem__1muai"};